import { Team__Adrianes } from "../2025_mens_b/teams/Adrianes";
import { Team__Cerveceros_2 } from "../2025_mens_b/teams/Cerveceros_2";
import { Team__Joeles } from "../2025_mens_b/teams/Joeles";
import { Team__Llamas } from "../2025_mens_b/teams/Llamas";
import { Team__Lorenas } from "../2025_mens_b/teams/Lorenas";
import { Team__LosQuintanas } from "../2025_mens_b/teams/LosQuintanas";
import { Team__Natalias } from "../2025_mens_b/teams/Natalias";
import { Team__PecanBros } from "../2025_mens_b/teams/PecanBros";
import { Team__Potros } from "../2025_mens_b/teams/Potros";
import { Team__Pythons } from "../2025_mens_b/teams/Pythons";
import { Team__RoadRunner } from "../2025_mens_b/teams/RoadRunner";
import { Team__RWE } from "../2025_mens_b/teams/RWE";
import { Team__Wolfpack } from "../2025_mens_b/teams/Wolfpack";

const GroupA = [Team__Llamas, Team__Wolfpack, Team__Potros, Team__Cerveceros_2];

const GroupB = [Team__RWE, Team__LosQuintanas, Team__Natalias, Team__Pythons];

const GroupC = [
  Team__Adrianes,
  Team__PecanBros,
  Team__RoadRunner,
  Team__Joeles,
];

export const Groups_2025_B = [GroupA, GroupB, GroupC];
